var map = {
	"./DS_Neo.svg": 56801,
	"./DS_min.svg": 27136,
	"./about-service.svg": 47427,
	"./access.svg": 65096,
	"./activity-outline.svg": 67863,
	"./activity.svg": 91882,
	"./acts.svg": 10064,
	"./add.svg": 73881,
	"./alert-circle-outline.svg": 94253,
	"./alert-circle.svg": 32773,
	"./alert-triangle-outline.svg": 42623,
	"./alert-triangle.svg": 48184,
	"./angle-white.svg": 57928,
	"./archive-outline.svg": 39576,
	"./archive.svg": 93173,
	"./arrow-back-outline.svg": 8397,
	"./arrow-back.svg": 85789,
	"./arrow-circle-down-outline.svg": 98095,
	"./arrow-circle-down.svg": 97897,
	"./arrow-circle-left-outline.svg": 2710,
	"./arrow-circle-left.svg": 34535,
	"./arrow-circle-right-outline.svg": 56770,
	"./arrow-circle-right.svg": 60189,
	"./arrow-circle-up-outline.svg": 69921,
	"./arrow-circle-up.svg": 20810,
	"./arrow-down-outline.svg": 29019,
	"./arrow-down.svg": 10432,
	"./arrow-downward-outline.svg": 63874,
	"./arrow-downward.svg": 34068,
	"./arrow-forward-outline.svg": 18460,
	"./arrow-forward.svg": 66888,
	"./arrow-ios-back-outline.svg": 43203,
	"./arrow-ios-back.svg": 15707,
	"./arrow-ios-downward-outline.svg": 2918,
	"./arrow-ios-downward.svg": 69593,
	"./arrow-ios-forward-outline.svg": 94267,
	"./arrow-ios-forward.svg": 59906,
	"./arrow-ios-upward-outline.svg": 4923,
	"./arrow-ios-upward.svg": 13056,
	"./arrow-left-outline.svg": 63452,
	"./arrow-left.svg": 5606,
	"./arrow-right-outline.svg": 73655,
	"./arrow-right.svg": 21576,
	"./arrow-up-outline.svg": 45460,
	"./arrow-up.svg": 86618,
	"./arrow-upward-outline.svg": 14086,
	"./arrow-upward.svg": 58731,
	"./arrowhead-down-outline.svg": 33580,
	"./arrowhead-down.svg": 90232,
	"./arrowhead-left-outline.svg": 34176,
	"./arrowhead-left.svg": 82857,
	"./arrowhead-right-outline.svg": 70713,
	"./arrowhead-right.svg": 22516,
	"./arrowhead-up-outline.svg": 54817,
	"./arrowhead-up.svg": 35421,
	"./asc.svg": 87782,
	"./attachment.svg": 7060,
	"./attention-filled.svg": 87181,
	"./attention.svg": 16775,
	"./award-2.svg": 76804,
	"./award-outline.svg": 65044,
	"./award.svg": 70369,
	"./backspace-outline.svg": 40149,
	"./backspace.svg": 20875,
	"./bank.svg": 32876,
	"./battery-outline.svg": 45922,
	"./battery.svg": 44176,
	"./behance-outline.svg": 89896,
	"./behance.svg": 86434,
	"./bell-off-outline.svg": 46889,
	"./bell-off.svg": 44575,
	"./bell-outline.svg": 68679,
	"./bell.svg": 12713,
	"./bluetooth-outline.svg": 52669,
	"./bluetooth.svg": 10298,
	"./bonus.svg": 89476,
	"./book-open-outline.svg": 10979,
	"./book-open.svg": 70298,
	"./book-outline.svg": 9109,
	"./bookmark.svg": 30511,
	"./books.svg": 15353,
	"./branch.svg": 53696,
	"./briefcase-outline.svg": 98176,
	"./briefcase.svg": 55574,
	"./browser-outline.svg": 94613,
	"./browser.svg": 83625,
	"./brush-outline.svg": 34169,
	"./brush.svg": 85728,
	"./business.svg": 55187,
	"./calc.svg": 68243,
	"./calendar.svg": 59820,
	"./camera-outline.svg": 33157,
	"./camera.svg": 76606,
	"./car-outline.svg": 74461,
	"./car.svg": 28587,
	"./card.svg": 20528,
	"./caret-down.svg": 50739,
	"./caret-left.svg": 61154,
	"./caret-right.svg": 84483,
	"./caret-up.svg": 32622,
	"./cast-outline.svg": 6777,
	"./cast.svg": 30519,
	"./charging-outline.svg": 64356,
	"./charging.svg": 38971,
	"./chart-bar.svg": 94817,
	"./chart-column.svg": 53967,
	"./chart-donut.svg": 36627,
	"./chart-line.svg": 45786,
	"./check-checked.svg": 37139,
	"./check-circle.svg": 62119,
	"./check-uncheck.svg": 37650,
	"./check.svg": 69023,
	"./checklist.svg": 47072,
	"./checkmark-circle-2-outline.svg": 95278,
	"./checkmark-circle-2.svg": 52564,
	"./checkmark-circle-outline.svg": 92777,
	"./checkmark-circle.svg": 4295,
	"./checkmark-outline.svg": 69604,
	"./checkmark.svg": 525,
	"./chevron-double-down.svg": 57177,
	"./chevron-double-left.svg": 62378,
	"./chevron-double-right.svg": 14468,
	"./chevron-double-up.svg": 7595,
	"./chevron-down-outline.svg": 75202,
	"./chevron-down.svg": 18802,
	"./chevron-left-outline.svg": 92215,
	"./chevron-left.svg": 37479,
	"./chevron-right-outline.svg": 12010,
	"./chevron-right.svg": 7603,
	"./chevron-up-outline.svg": 73776,
	"./chevron-up.svg": 83686,
	"./clip.svg": 44454,
	"./clock-outline.svg": 77814,
	"./clock.svg": 25892,
	"./close-circle-outline.svg": 34396,
	"./close-circle.svg": 46045,
	"./close-outline.svg": 79346,
	"./close-square-outline.svg": 22112,
	"./close-square.svg": 62510,
	"./close.svg": 72670,
	"./cloud-upload.svg": 69015,
	"./code-download-outline.svg": 50556,
	"./code-download.svg": 14875,
	"./code-outline.svg": 18365,
	"./code.svg": 23184,
	"./coliseum.svg": 95871,
	"./collapse-outline.svg": 71343,
	"./collapse.svg": 12134,
	"./color-palette-outline.svg": 34887,
	"./color-palette.svg": 50497,
	"./color-picker-outline.svg": 41589,
	"./color-picker.svg": 18733,
	"./compass-outline.svg": 60469,
	"./compass.svg": 31894,
	"./context-menu.svg": 8253,
	"./copy.svg": 43154,
	"./corner-down-left-outline.svg": 16585,
	"./corner-down-left.svg": 63555,
	"./corner-down-right-outline.svg": 6319,
	"./corner-down-right.svg": 15250,
	"./corner-left-down-outline.svg": 4998,
	"./corner-left-down.svg": 67905,
	"./corner-left-up-outline.svg": 10819,
	"./corner-left-up.svg": 71595,
	"./corner-right-down-outline.svg": 96624,
	"./corner-right-down.svg": 35239,
	"./corner-right-up-outline.svg": 45046,
	"./corner-right-up.svg": 45338,
	"./corner-up-left-outline.svg": 71424,
	"./corner-up-left.svg": 7676,
	"./corner-up-right-outline.svg": 98273,
	"./corner-up-right.svg": 6219,
	"./crop-outline.svg": 91476,
	"./crop.svg": 62699,
	"./cube-outline.svg": 48218,
	"./cube.svg": 20631,
	"./dashboard.svg": 99388,
	"./delete.svg": 32032,
	"./desc.svg": 62776,
	"./diagonal-arrow-left-down-outline.svg": 13175,
	"./diagonal-arrow-left-down.svg": 78713,
	"./diagonal-arrow-left-up-outline.svg": 84663,
	"./diagonal-arrow-left-up.svg": 85162,
	"./diagonal-arrow-right-down-outline.svg": 76721,
	"./diagonal-arrow-right-down.svg": 78568,
	"./diagonal-arrow-right-up-outline.svg": 25465,
	"./diagonal-arrow-right-up.svg": 13871,
	"./dice.svg": 36801,
	"./directory.svg": 23779,
	"./done-all-outline.svg": 83055,
	"./done-all.svg": 65881,
	"./down.svg": 40228,
	"./download.svg": 85291,
	"./droplet-off-outline.svg": 38012,
	"./droplet-off.svg": 30599,
	"./droplet-outline.svg": 30571,
	"./droplet.svg": 22522,
	"./eclipse-loader.svg": 69250,
	"./edit-2-outline.svg": 82096,
	"./edit-2.svg": 7577,
	"./edit-outline.svg": 69641,
	"./edit.svg": 86605,
	"./email.svg": 718,
	"./envelope.svg": 66172,
	"./error-filled.svg": 16455,
	"./error.svg": 83078,
	"./expand-2.svg": 70758,
	"./expand-outline.svg": 18282,
	"./expand.svg": 66392,
	"./external-link-outline.svg": 86672,
	"./external-link.svg": 52521,
	"./eye-off-2-outline.svg": 23372,
	"./eye-off-2.svg": 28444,
	"./eye-off-outline.svg": 17871,
	"./eye-off.svg": 87791,
	"./eye-on.svg": 87802,
	"./fa-line-chart.svg": 99452,
	"./fa-university.svg": 63423,
	"./facebook-outline.svg": 61994,
	"./facebook.svg": 70901,
	"./favorite.svg": 52357,
	"./file-add-outline.svg": 45817,
	"./file-add.svg": 72210,
	"./file-download.svg": 15176,
	"./file-outline.svg": 41173,
	"./file-protect.svg": 82172,
	"./file-remove-outline.svg": 49693,
	"./file-remove.svg": 19286,
	"./file-text-outline.svg": 65709,
	"./file-text.svg": 41783,
	"./file-upload.svg": 25802,
	"./file-xls.svg": 72724,
	"./file.svg": 45520,
	"./film-outline.svg": 95624,
	"./film.svg": 64434,
	"./filter-lines.svg": 42273,
	"./filter.svg": 70791,
	"./flag-outline.svg": 22336,
	"./flag.svg": 4731,
	"./flash-off-outline.svg": 76338,
	"./flash-off.svg": 34283,
	"./flash-outline.svg": 71856,
	"./flash.svg": 23715,
	"./flip-2-outline.svg": 97772,
	"./flip-2.svg": 4188,
	"./flip-outline.svg": 20565,
	"./flip.svg": 1286,
	"./folder-add-outline.svg": 2296,
	"./folder-add.svg": 23876,
	"./folder-outline.svg": 73898,
	"./folder-remove-outline.svg": 35567,
	"./folder-remove.svg": 86419,
	"./folder.svg": 37018,
	"./full-size.svg": 76304,
	"./gamepad.svg": 12292,
	"./gift-outline.svg": 88456,
	"./gift.svg": 90335,
	"./github-outline.svg": 6365,
	"./github.svg": 45106,
	"./globe-off.svg": 69664,
	"./globe-wait.svg": 80015,
	"./globe.svg": 99666,
	"./google-outline.svg": 95386,
	"./google.svg": 37624,
	"./green-plane.svg": 44025,
	"./grid-outline.svg": 12687,
	"./grid.svg": 33389,
	"./hard-drive-outline.svg": 32972,
	"./hard-drive.svg": 39698,
	"./hash-outline.svg": 81936,
	"./hash.svg": 26495,
	"./headphones-outline.svg": 55898,
	"./headphones-with-microphone.svg": 23400,
	"./headphones.svg": 11357,
	"./heart-outline.svg": 1393,
	"./heart.svg": 2269,
	"./help.svg": 40311,
	"./home-new.svg": 19302,
	"./home-outline.svg": 40952,
	"./home.svg": 36456,
	"./icon-check.svg": 19722,
	"./icon-close.svg": 84957,
	"./image-2.svg": 68100,
	"./image-outline.svg": 94636,
	"./image.svg": 21648,
	"./inbox-outline.svg": 62233,
	"./inbox.svg": 81746,
	"./info-2.svg": 45522,
	"./info-outline.svg": 92580,
	"./info.svg": 21815,
	"./ip_order.svg": 1368,
	"./keypad-outline.svg": 94423,
	"./keypad.svg": 19,
	"./layers-outline.svg": 54602,
	"./layers.svg": 69165,
	"./layout-outline.svg": 19773,
	"./layout.svg": 51103,
	"./lightbulb.svg": 42884,
	"./lightbuld-outlined.svg": 95771,
	"./link-2-outline.svg": 58157,
	"./link-2.svg": 84341,
	"./link-out.svg": 81008,
	"./link-outline.svg": 62401,
	"./link.svg": 1317,
	"./linkedin-outline.svg": 38737,
	"./linkedin.svg": 23706,
	"./list-outline.svg": 69522,
	"./list.svg": 56948,
	"./loader-outline.svg": 74431,
	"./loader.svg": 60632,
	"./loader2.svg": 17058,
	"./location-map.svg": 26343,
	"./location-pos.svg": 32548,
	"./lock-open.svg": 56839,
	"./lock-outline.svg": 97163,
	"./lock.svg": 2857,
	"./log-in-outline.svg": 47979,
	"./log-in.svg": 19811,
	"./log-out-outline.svg": 93525,
	"./log-out.svg": 14275,
	"./logo-ds-sber.svg": 87471,
	"./logo-neo.svg": 51027,
	"./logo-sber.svg": 73934,
	"./logoDS-gray.svg": 80362,
	"./logoDS.svg": 47837,
	"./logoLINE.svg": 43439,
	"./logoSBER.svg": 21856,
	"./logout.svg": 12701,
	"./logs.svg": 54490,
	"./loyality.svg": 61081,
	"./map-outline.svg": 95442,
	"./map-pin.svg": 45506,
	"./map.svg": 54257,
	"./maximize-outline.svg": 96961,
	"./maximize.svg": 55559,
	"./menu-2-outline.svg": 71810,
	"./menu-2.svg": 99946,
	"./menu-arrow-outline.svg": 28620,
	"./menu-arrow.svg": 68970,
	"./menu-outline.svg": 23901,
	"./menu.svg": 43270,
	"./menu4.svg": 21851,
	"./message-circle-outline.svg": 58640,
	"./message-circle.svg": 58402,
	"./message-outline.svg": 21257,
	"./message-square-outline.svg": 82429,
	"./message-square.svg": 78717,
	"./message.svg": 2342,
	"./mic-off-outline.svg": 85343,
	"./mic-off.svg": 76524,
	"./mic-outline.svg": 37970,
	"./mic.svg": 70498,
	"./minimize-outline.svg": 49982,
	"./minimize.svg": 20277,
	"./minus-circle-outline.svg": 67359,
	"./minus-circle.svg": 90359,
	"./minus-outline.svg": 26758,
	"./minus-square-outline.svg": 19504,
	"./minus-square.svg": 78247,
	"./minus-white.svg": 23418,
	"./minus.svg": 47104,
	"./mobile.svg": 58973,
	"./monitor-outline.svg": 12678,
	"./monitor.svg": 55837,
	"./moon-outline.svg": 18970,
	"./moon.svg": 33405,
	"./more-horizontal-outline.svg": 52806,
	"./more-horizontal.svg": 42267,
	"./more-vertical-outline.svg": 60700,
	"./more-vertical.svg": 45736,
	"./move-outline.svg": 88772,
	"./move.svg": 97867,
	"./music-outline.svg": 24839,
	"./music.svg": 59711,
	"./navigation-2-outline.svg": 12242,
	"./navigation-2.svg": 11751,
	"./navigation-outline.svg": 7241,
	"./navigation.svg": 79636,
	"./new-article.svg": 73752,
	"./new-project.svg": 53446,
	"./new-video.svg": 50779,
	"./news.svg": 29378,
	"./news2.svg": 13582,
	"./notification.svg": 54803,
	"./npm-outline.svg": 11593,
	"./npm.svg": 61241,
	"./offline_identification.svg": 93987,
	"./oko.svg": 8939,
	"./online_identification.svg": 26445,
	"./ooo_order.svg": 52791,
	"./options-2-outline.svg": 70888,
	"./options-2.svg": 88934,
	"./options-outline.svg": 83341,
	"./options.svg": 23980,
	"./oval.svg": 41829,
	"./pantone-outline.svg": 99314,
	"./pantone.svg": 3794,
	"./paper-plane-outline.svg": 94262,
	"./paper-plane-rounded.svg": 66645,
	"./paper-plane.svg": 92416,
	"./paper.svg": 24085,
	"./pause-circle-outline.svg": 15715,
	"./pause-circle.svg": 17562,
	"./payment-success.svg": 89052,
	"./payment-wait.svg": 83406,
	"./pdf.svg": 18918,
	"./people-outline.svg": 4979,
	"./people.svg": 73342,
	"./percent-outline.svg": 27676,
	"./percent.svg": 2933,
	"./person-add-outline.svg": 77160,
	"./person-add.svg": 13239,
	"./person-delete-outline.svg": 54973,
	"./person-delete.svg": 75518,
	"./person-done-outline.svg": 13821,
	"./person-done.svg": 5566,
	"./person-outline.svg": 31444,
	"./person-remove-outline.svg": 30533,
	"./person-remove.svg": 45554,
	"./person-small.svg": 76658,
	"./person.svg": 14997,
	"./phone-call-outline.svg": 73416,
	"./phone-call.svg": 79840,
	"./phone-missed-outline.svg": 6357,
	"./phone-missed.svg": 77652,
	"./phone-off-outline.svg": 2414,
	"./phone-off.svg": 79000,
	"./phone-outline.svg": 65967,
	"./phone-outlined.svg": 13886,
	"./phone.svg": 71525,
	"./pie-chart-2.svg": 52349,
	"./play-circle-outline.svg": 11989,
	"./play-circle.svg": 57827,
	"./plus-circle.svg": 62910,
	"./plus.svg": 61775,
	"./polls.svg": 23048,
	"./position.svg": 8319,
	"./power-outline.svg": 53984,
	"./power.svg": 63095,
	"./pre-approved.svg": 69631,
	"./pricetags-outline.svg": 24974,
	"./pricetags.svg": 74027,
	"./printer-outline.svg": 74715,
	"./printer.svg": 4657,
	"./products-service.svg": 19318,
	"./products.svg": 14567,
	"./profile.svg": 90269,
	"./qr-code.svg": 8796,
	"./quality-control.svg": 75567,
	"./quarantee.svg": 89579,
	"./question-mark-circle-outline.svg": 13817,
	"./question-mark-circle-small.svg": 99133,
	"./question-mark-circle.svg": 27478,
	"./question-mark-outline.svg": 59658,
	"./question-mark.svg": 17274,
	"./queue.svg": 76578,
	"./quote-arrow-back.svg": 65532,
	"./radio-button-off-outline.svg": 23298,
	"./radio-button-on.svg": 7118,
	"./radio-outline.svg": 59143,
	"./radio.svg": 63442,
	"./recommendation.svg": 46391,
	"./recording-outline.svg": 64339,
	"./recording.svg": 91001,
	"./refresh-outline.svg": 96184,
	"./refresh.svg": 78880,
	"./reload.svg": 27466,
	"./repeat-outline.svg": 9549,
	"./repeat.svg": 55307,
	"./reserve-off.svg": 18738,
	"./reserve-wait.svg": 25671,
	"./reserve.svg": 80720,
	"./rewind-left-outline.svg": 44163,
	"./rewind-left.svg": 63690,
	"./rewind-right-outline.svg": 28232,
	"./rewind-right.svg": 86961,
	"./robot.svg": 34376,
	"./rub.svg": 71623,
	"./ruble-big-square.svg": 71929,
	"./ruble-circle.svg": 63575,
	"./ruble-square.svg": 3983,
	"./ruble.svg": 41337,
	"./safe-cross-out.svg": 91176,
	"./safe.svg": 9568,
	"./save-outline.svg": 97852,
	"./save.svg": 44721,
	"./sber-logo.svg": 97926,
	"./sberID.svg": 28276,
	"./sber_identification.svg": 63353,
	"./sbr.svg": 33672,
	"./scissors-outline.svg": 92403,
	"./scissors.svg": 24217,
	"./search-outline.svg": 57333,
	"./search.svg": 53336,
	"./send.svg": 91213,
	"./service-filling.svg": 75866,
	"./settings-2-outline.svg": 85021,
	"./settings-2.svg": 26329,
	"./settings-outline.svg": 18446,
	"./settings.svg": 45834,
	"./shake-outline.svg": 83199,
	"./shake.svg": 72223,
	"./share-outline.svg": 15496,
	"./share.svg": 13659,
	"./shield-off-outline.svg": 48407,
	"./shield-off.svg": 7406,
	"./shield-outline.svg": 21838,
	"./shield.svg": 89523,
	"./shopping-bag-outline.svg": 2953,
	"./shopping-bag.svg": 4148,
	"./shopping-cart-outline.svg": 27096,
	"./shopping-cart.svg": 45939,
	"./show-collapse.svg": 62605,
	"./show-full.svg": 45018,
	"./shuffle-2-outline.svg": 62560,
	"./shuffle-2.svg": 72266,
	"./shuffle-outline.svg": 39221,
	"./shuffle.svg": 56843,
	"./signature.svg": 45955,
	"./skip-back-outline.svg": 86385,
	"./skip-back.svg": 36249,
	"./skip-forward-outline.svg": 30189,
	"./skip-forward.svg": 39678,
	"./slash-outline.svg": 623,
	"./slash.svg": 85244,
	"./small-size.svg": 82690,
	"./smartphone-outline.svg": 83788,
	"./smartphone.svg": 15905,
	"./smiling-face-outline.svg": 89611,
	"./smiling-face.svg": 51413,
	"./sms-letter.svg": 31717,
	"./sms.svg": 47783,
	"./sort-down.svg": 28538,
	"./sort-left.svg": 67339,
	"./sort-right.svg": 60332,
	"./sort-up.svg": 92120,
	"./sort_asc.svg": 36441,
	"./sort_desc.svg": 48891,
	"./speaker-outline.svg": 31302,
	"./speaker.svg": 64521,
	"./square-outline.svg": 94572,
	"./square.svg": 26386,
	"./star-outline.svg": 79305,
	"./star.svg": 33078,
	"./step-account.svg": 56606,
	"./step-organization-profile.svg": 96220,
	"./stop-circle-outline.svg": 38020,
	"./stop-circle.svg": 3015,
	"./sun-outline.svg": 62437,
	"./sun.svg": 52391,
	"./support.svg": 44576,
	"./swap-outline.svg": 80162,
	"./swap-outlined.svg": 79263,
	"./swap.svg": 96655,
	"./sync-outline.svg": 2891,
	"./sync.svg": 74021,
	"./synchronize.svg": 7201,
	"./telegram.svg": 57362,
	"./text-outline.svg": 67438,
	"./text.svg": 65235,
	"./thermometer-minus-outline.svg": 44703,
	"./thermometer-minus.svg": 47770,
	"./thermometer-outline.svg": 44397,
	"./thermometer-plus-outline.svg": 61566,
	"./thermometer-plus.svg": 28397,
	"./thermometer.svg": 32792,
	"./time-fast.svg": 19711,
	"./time.svg": 51695,
	"./toggle-left-outline.svg": 54169,
	"./toggle-left.svg": 22829,
	"./toggle-right-outline.svg": 8068,
	"./toggle-right.svg": 83742,
	"./top-150.svg": 8813,
	"./trash-2-outline.svg": 10874,
	"./trash-2.svg": 70359,
	"./trash-3-outline.svg": 40434,
	"./trash-4.svg": 1483,
	"./trash-chat.svg": 81253,
	"./trash-outline-3.svg": 78949,
	"./trash-outline.svg": 12466,
	"./trash.svg": 87053,
	"./trending-down-outline.svg": 57235,
	"./trending-down.svg": 68712,
	"./trending-up-outline.svg": 46471,
	"./trending-up.svg": 86925,
	"./tv-outline.svg": 62247,
	"./tv.svg": 32002,
	"./twitter-outline.svg": 8297,
	"./twitter.svg": 19615,
	"./umbrella-outline.svg": 69112,
	"./umbrella.svg": 15279,
	"./undo-outline.svg": 22825,
	"./undo.svg": 97215,
	"./union.svg": 20021,
	"./unlock-outline.svg": 65768,
	"./unlock.svg": 80914,
	"./up.svg": 98986,
	"./upload-outline.svg": 21048,
	"./upload.svg": 72422,
	"./user.svg": 81763,
	"./vector.svg": 27877,
	"./video-off-outline.svg": 58966,
	"./video-off.svg": 38975,
	"./video-outline.svg": 36403,
	"./video.svg": 537,
	"./view-collapsed.svg": 95949,
	"./view-details.svg": 22938,
	"./view-more.svg": 14463,
	"./vkm.svg": 93528,
	"./volume-down-outline.svg": 95719,
	"./volume-down.svg": 78088,
	"./volume-mute-outline.svg": 14545,
	"./volume-mute.svg": 5338,
	"./volume-off-outline.svg": 21692,
	"./volume-off.svg": 32612,
	"./volume-up-outline.svg": 64568,
	"./volume-up.svg": 41138,
	"./wallet.svg": 95339,
	"./wide-check.svg": 98317,
	"./wifi-off-outline.svg": 30552,
	"./wifi-off.svg": 94357,
	"./wifi-outline.svg": 30442,
	"./wifi.svg": 13973,
	"./xls.svg": 35290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15934;